import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {gqlAutomaticPayment} from '../getAutomaticPayment.api';
import {AutomaticPayment} from '../../../graphql/payments.datatypes';

export interface CreateAutomaticPaymentInput {
    data: {
        payment_token: string
        payment_type: number
        billing_party_member_id: number
        payment_frequency: number
        last_four?: string
        routing_number?: string
    }
}

interface CreateAutomaticPaymentData {
    createAutomaticPayment: AutomaticPayment
}

export const CREATE_AUTOMATIC_PAYMENT_MUTATION = gql`
    mutation createAutomaticPayment($data: CreateAutomaticPaymentInput!) {
        createAutomaticPayment(data: $data) {
            ${gqlAutomaticPayment}
        }
    }
`;

export const createAutomaticPayment = () => useMutation<CreateAutomaticPaymentData, CreateAutomaticPaymentInput>(
    CREATE_AUTOMATIC_PAYMENT_MUTATION,
    {
        update: updateCacheByType('BillingParty'),
    }
);

export default createAutomaticPayment;
